import { memoize } from 'proxy-memoize';

import { RootState } from '../../app/storeTypes';
import { DropDownOptions } from '../../types';
const loanOptionSliceCheck = (state: RootState) => {
    if (!state.loanOption) { throw new Error('Loan Option slice not added to store'); }

    return state.loanOption;
};

export const selectLoanOptionAEM = (state: RootState) => {
    const { content } = loanOptionSliceCheck(state);

    return content;
};

export const selectLoanOptions = (state: RootState) => {
    const { loanOptionData } = loanOptionSliceCheck(state);

    return loanOptionData.loanOptions;
};

export const selectIsShowLoanOptionTabs = (state: RootState) => {
    const { loanOptionData } = loanOptionSliceCheck(state);

    return loanOptionData.isShowLoanOptionTabs;
};

export const selectLoanOptionTabs = (state: RootState) => {
    const { loanOptionData } = loanOptionSliceCheck(state);

    return loanOptionData.loanOptionTabs;
};

export const selectIsShowExceedInfo = (state: RootState) => {
    const { loanOptionData } = loanOptionSliceCheck(state);

    return loanOptionData.isShowExceedInfo;
};

export const selectExceedInfo = (state: RootState) => {
    const { loanOptionData } = loanOptionSliceCheck(state);

    return loanOptionData.exceedInfo;
};

export const selectIsShowNotification = (state: RootState) => {
    const { loanOptionData } = loanOptionSliceCheck(state);

    return loanOptionData.isShowNotification;
};

export const selectNotification = (state: RootState) => {
    const { loanOptionData } = loanOptionSliceCheck(state);

    return loanOptionData.notification;
};

export const selectLoanOptionLoanAmountDropdownOptions = memoize((state: RootState) => {
    const { content } = loanOptionSliceCheck(state);

    return Object.values(content.loanAmount).reduce(
        (acc: DropDownOptions<string>[], curr) => [
            ...acc,
            { label: curr.key, value: curr.value.toString() },
        ],
        [],
    );
});

export const selectLoanOptionLoanTermYearDropdownOptions = memoize((state: RootState) => {
    const { content } = loanOptionSliceCheck(state);

    return Object.values(content.loanTerm).reduce(
        (acc: DropDownOptions<string>[], curr) => [
            ...acc,
            { label: curr.key, value: curr.value.toString() },
        ],
        [],
    );
});

export const selectLoanOptionRepaymentFrequencyDropdownOptions = memoize((state: RootState) => {
    const { content } = loanOptionSliceCheck(state);

    return Object.values(content.frequency).reduce(
        (acc: DropDownOptions<string>[], curr) => [
            ...acc,
            { label: curr.key, value: curr.value.toString() },
        ],
        [],
    );
});

export const selectLoanOptionFormDetail = (state: RootState) => {
    const { loanOptionFormDetail } = loanOptionSliceCheck(state);

    return loanOptionFormDetail;
};

export const selectUpdateLoanOptionRequest = (state: RootState) => {
    const { updateLoanOptionFormDetailRequest } = loanOptionSliceCheck(state);

    return updateLoanOptionFormDetailRequest;
};

export const selectGetLoanOptionUrl = (state: RootState) => {
    const { apiEndpoints } = loanOptionSliceCheck(state);

    return apiEndpoints.getLoanOptionApiUrl;
};

export const selectUpdateLoanOptionFormDetailUrl = (state: RootState) => {
    const { apiEndpoints } = loanOptionSliceCheck(state);

    return apiEndpoints.updateLoanOptionFormDetailApiUrl;
};

export const selectGetLoanOptionApiStatus = (state: RootState) => {
    const { getLoanOptionApiStatus } = loanOptionSliceCheck(state);

    return getLoanOptionApiStatus;
};

export const selectUpdateLoanOptionApiStatus = (state: RootState) => {
    const { updateLoanOptionFormDetailApiStatus } = loanOptionSliceCheck(state);

    return updateLoanOptionFormDetailApiStatus;
};
